<template>
  <section class="qrs-typography">
    <pageHeader>
      <h1 class="qrs-header-xl">Share</h1>
    </pageHeader>

    <p>
      Please enter the email address to send your
      <strong>"Getting to know me"</strong> PDF to, as well as your name.
    </p>

    <button
      name="Cancel"
      aria-label="Cancel share via email action"
      class="govuk-button govuk-button--secondary mt--24"
      :goBack="goBack"
    >
      Cancel
      <span class="screen-reader-text">Cancel share via email action</span>
    </button>
  </section>
</template>

<script>
export default {
  methods: {
    goBack() {
      this.$parent.goTo(this.$Share);
    },
  },
};
</script>